import { html, nothing } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html';
import componentStyles from './page-header.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';
import hfMark from '../icon/assets/icons/hf-mark.svg'

export default class PageHeader extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      styleclass: { type: String },
    };
  }

  constructor() {
    super();
    this.styleclass = 'default'
  }

  render() {
    this.print = this.styleclass === 'recipe';
    return html`
      <div class="page-header__wrapper page-header__wrapper--${this.styleclass}">
        <slot name="breadcrumb" class="page-header__breadcrumb"></slot>
        <slot name="header-main" class="page-header__header-main"></slot>
        <slot
          name="header-published"
          class="page-header__header-published"
        ></slot>
        <slot name="share" class="page-header__share"></slot>
        <span class="page-header__icon">${unsafeHTML(hfMark)}</span>
      </div>
    `;
  }
}
customElements.define('hf-page-header', PageHeader);
